import { ComponentRef, Injectable, Type } from '@angular/core';
import { Subject } from 'rxjs';

type Componente = Type<any>;

@Injectable({
	providedIn: 'root',
})
export class AreaTemporariaService {
	public component = new Subject<{
		componente: Componente | null;
		input?: Record<string, any>;
		callbackReferencia?: (refencia: ComponentRef<any>) => void;
	}>();

	setConteudo<T extends Componente>(
		template: T,
		estados: object,
		callbackReferencia?: (referencia: ComponentRef<any>) => void
	): void {
		this.component.next({
			componente: template,
			input: estados,
			callbackReferencia,
		});
	}

	limparConteudo(): void {
		this.component.next({ componente: null });
	}
}
